import { ACCOUNT_INITIALIZE } from './accountActions';

export const initialState = {
    isInitialized: false,
    language: {},
    settings: {}
};

const accountReducer = (state = initialState, action) => {
    switch (action.type) {
        case ACCOUNT_INITIALIZE: {
            const { language, settings } = action.payload;
            return {
                ...state,
                isInitialized: true,
                language,
                settings
            };
        }
        default: {
            return { ...state };
        }
    }
};

export default accountReducer;
